import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Accordion } from 'semantic-ui-react';

import _isNumber from 'lodash/isNumber';
import { useDispatch, useSelector } from 'react-redux';

import { getItemModifierSets } from './MenuItemModifierSets.utils';
import { addMenuModifierSet } from '../../../../../actions/business';
import { selectBusinessModifierSets } from '../../../../../selectors/catalog';
import { CatalogItemPropType } from '../../../../modules/catalog/proptypes/catalog';
import AddModifierSet from '../AddModifierSet/AddModifierSet';
import MenuItemModifierSet from '../MenuItemModifierSet/MenuItemModifierSet';

const propTypes = {
  itemIndex: PropTypes.number.isRequired,
  item: CatalogItemPropType,
  onItemModifierSetsChange: PropTypes.func,
};

const defaultProps = {
  item: {},
  onItemModifierSetsChange: () => null,
};

export default function MenuItemModifierSets({
  itemIndex,
  item,
  onItemModifierSetsChange: onItemModifierSetsChangeProp,
}) {
  const dispatch = useDispatch();

  const allModifierSets = useSelector(selectBusinessModifierSets);

  const { id: itemId, modifierSets: initialItemModifierSetIds = [] } = item || {};

  const [itemModifierSetIds, setItemModifierSetIds] = useState([...initialItemModifierSetIds]);
  const itemModifierSets = getItemModifierSets(allModifierSets, itemModifierSetIds);

  const [openModifierSetIndex, setOpenModifierSetIndex] = useState(null);

  function handleModifierSetClick(index) {
    if (index === openModifierSetIndex) {
      setOpenModifierSetIndex(null);
    } else {
      setOpenModifierSetIndex(index);
    }
  }

  function onItemModifierSetsChange(newItemModifierSetIds) {
    setItemModifierSetIds(newItemModifierSetIds);
    onItemModifierSetsChangeProp(newItemModifierSetIds);
  }

  useEffect(() => {
    const newItemModifierSetIds = itemModifierSets
      .filter(({ id }) => _isNumber(id))
      .map(({ id }) => id);

    onItemModifierSetsChange(newItemModifierSetIds);
  }, [itemModifierSets.length]);

  function onAddMenuModifierSet() {
    dispatch(addMenuModifierSet({ itemIndex }));
  }

  function onLinkItemModifierSet(modifierSetId) {
    const newItemModifierSets = [
      ...new Set([...itemModifierSetIds.filter((id) => _isNumber(id)), modifierSetId]),
    ];

    onItemModifierSetsChange(newItemModifierSets);
  }

  function onCreateModifierSet({ id: modifierSetId }) {
    onLinkItemModifierSet(modifierSetId);
  }

  function onRemoveMenuItemModifier(modifierSetId) {
    const newItemModifierSets = itemModifierSetIds.filter((id) => id !== modifierSetId);

    onItemModifierSetsChange(newItemModifierSets);
  }

  return (
    <div>
      <Accordion>
        {itemModifierSets.map((modifierSet, localIndex) => {
          const { id, index, localId } = modifierSet;

          return (
            <MenuItemModifierSet
              key={`modifier_set_${id || localId}`}
              index={index}
              modifierSet={modifierSet}
              itemIndex={itemIndex}
              itemId={itemId}
              onCreate={onCreateModifierSet}
              onClick={() => handleModifierSetClick(localIndex)}
              onRemoveMenuItemModifier={onRemoveMenuItemModifier}
              active={localIndex === openModifierSetIndex}
            />
          );
        })}
      </Accordion>
      <AddModifierSet
        itemId={itemId}
        allModifierSets={allModifierSets}
        itemModifierSets={itemModifierSets}
        onAddNewSet={onAddMenuModifierSet}
        onAddExistingSet={onLinkItemModifierSet}
        showCreateNew={!!itemId}
      />
    </div>
  );
}

MenuItemModifierSets.propTypes = propTypes;
MenuItemModifierSets.defaultProps = defaultProps;
